import { render, staticRenderFns } from "./wechat-app.vue?vue&type=template&id=793e1630&scoped=true"
import script from "./wechat-app.vue?vue&type=script&lang=js"
export * from "./wechat-app.vue?vue&type=script&lang=js"
import style0 from "./wechat-app.vue?vue&type=style&index=0&id=793e1630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e1630",
  null
  
)

export default component.exports